import AppConfigurationList from './AppConfigurationList';
import { useEffect, useState } from 'react';
import CreateAppConfiguration from './CreateAppConfiguration';
import { useDispatch, useSelector } from 'react-redux';
import { appConfigurationSelector, fetchAppConfigurationsList } from '../configurationSlice';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { APP, CONFIGURATION, TABS } from './AppConfigurationConst';
import { selectedHotelSelector } from '../../property/propertySlice';
import { notificationManager } from '../../../utils/NotificationUtils';
import {
  createAppConfigurationsApi,
  updateAppConfigurationsApi,
} from '../../../utils/IntegrationsAPIUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    margin: theme.spacing(1),
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    margin: theme.spacing(1),
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const AppConfiguration = (props) => {
  const { showLoader = () => {} } = props;
  const appConfigurationList = useSelector(appConfigurationSelector);
  const selectedHotelId = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(null);
  const [activeTab, setActiveTab] = useState(APP);
  const [isShowList, setIsShowList] = useState(false);

  useEffect(() => {
    if (!selectedHotelId) return;
    dispatch(fetchAppConfigurationsList(selectedHotelId));
    setEditMode(null);
    setIsShowList(false);
  }, [selectedHotelId, dispatch]);

  const classes = useStyles();
  const handleAddAction = async (data) => {
    try {
      dispatch(stepUpLoaderCount());
      const payload = {
        ...data,
        type: activeTab,
        hotelId: selectedHotelId,
      };
      const isUpdate = !!editMode;
      const response = isUpdate
        ? await updateAppConfigurationsApi({ ...payload, id: editMode?.id })
        : await createAppConfigurationsApi(payload);
      const createRes = response?.data?.createAppConfiguration;
      const updateRes = response?.data?.updateAppConfiguration;
      const okId = createRes?.id || updateRes?.id;
      if (okId) {
        notificationManager(
          'success',
          `App configuration ${isUpdate ? 'updated' : 'created'} successfully`,
        );
        dispatch(fetchAppConfigurationsList(selectedHotelId));
        setEditMode(null);
        setIsShowList(false);
        return true;
      } else {
        const apiErr =
          createRes?.errors?.[0]?.message ||
          createRes?.message ||
          updateRes?.errors?.[0]?.message ||
          updateRes?.message;
        notificationManager(
          'danger',
          apiErr || `Failed to ${isUpdate ? 'update' : 'create'} app configuration`,
        );
        return false;
      }
    } catch (error) {
      if (error?.message) {
        notificationManager('danger', error.message);
      } else {
        notificationManager('danger', 'Error while adding / updating configuration');
      }
      return false;
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleEditAction = (editData) => {
    setIsShowList(true);
    setEditMode(editData);
  };

  const handleShowComponent = () => {
    if (isShowList) {
      return (
        <CreateAppConfiguration
          handleAddAction={handleAddAction}
          handleCancel={() => {
            setEditMode(null);
            setIsShowList(false);
          }}
          editMode={editMode}
          activeTab={activeTab}
          showLoader={showLoader}
        />
      );
    } else {
      return (
        <AppConfigurationList
          handleCreateApp={() => {
            setIsShowList(true);
          }}
          appConfigurationList={appConfigurationList}
          handleEdit={handleEditAction}
          type={activeTab}
          showLoader={showLoader}
        />
      );
    }
  };

  return (
    <>
      <div className='container mt-4'>
        <div className='row d-flex'>
          <div className='col-md-6'>
            <span className='page-title'>{CONFIGURATION}</span>
          </div>
        </div>
        {!isShowList && (
          <div className='row d-flex mt-4 accommodation-list'>
            <div className='d-flex'>
              {TABS?.map((tab) => (
                <Button
                  key={tab?.key}
                  size='large'
                  variant={activeTab === tab?.key ? 'outlined' : 'text'}
                  className={
                    activeTab === tab?.key ? classes.activeButton : classes.button + 'showpopup'
                  }
                  onClick={() => {
                    setActiveTab(tab?.key);
                  }}
                >
                  {tab?.name}
                </Button>
              ))}
            </div>
          </div>
        )}
        {handleShowComponent()}
      </div>
    </>
  );
};

export default AppConfiguration;
